import { useEffect } from 'react';

export function useInlineFont(fontUrl: string, fontName: string) {
  useEffect(() => {
    if (document.getElementById(fontName)) {
      return;
    }

    const fontFace = `
      @font-face {
        font-family: '${fontName}';
        src: url('${fontUrl}') format('truetype');
        font-weight: normal;
        font-style: normal;
      }
    `;
    const style = document.createElement('style');
    style.id = fontName;
    style.innerHTML = fontFace;
    document.head.appendChild(style);
  }, [fontUrl, fontName]);
}
